import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import AgencySettingsFactory from "../../Entity/Factories/AgencySettingsFactory";
import { ActionInterface } from "../../Interface/ActionInterface";
import { AgencySettingsInterface } from "../../Entity/Entities/Settings/Agency/AgencySettingsInterface";
import Translator from "../../Translation/Translator";

export default function* financialStartDateUpdate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.PAGE_SETTINGS_PREFERENCES_UPDATE_CLEAR
    });

    yield put({
      type: Constants.PAGE_SETTINGS_AGENCY_PROFILE_FINANCIAL_START_DATE_UPDATE_REQUEST
    });

    const res = yield call(Http.patch, `agency-settings/financial-start-date`, action.payload);
    const settings: AgencySettingsInterface = AgencySettingsFactory.create(res.data);

    yield put({
      type: Constants.PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_SUCCESS,
      payload: {
        settings: settings
      }
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-financial-start-date-updated-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {

    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.PAGE_SETTINGS_AGENCY_PROFILE_FINANCIAL_START_DATE_UPDATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchFinancialStartDateUpdate() {
  yield takeEvery(Constants.PAGE_SETTINGS_AGENCY_PROFILE_FINANCIAL_START_DATE_UPDATE_START, financialStartDateUpdate);
}
